<div class="layout-footer">
	<div class="footer-left">
		<!-- <img [src]="'assets/layout/images/logo-' + (app.layoutColor === 'white' ? 'dark' : 'white') + '.png'" alt="logo" />
        <span class="app-name">Verona</span> -->
	</div>
	<div class="footer-right">
		<span>© Ubiq</span>
	</div>
</div>
